import { Container, CssBaseline, Grid, Paper } from "@mui/material";
import SideImage from "../ui/Authentication/SideImage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ToastContainer />
      <Grid
        container
        component={Paper}
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        spacing={2}
      >
        <SideImage />
        <CssBaseline />
        <Grid
          // component={"main"}
          item
          xs={12}
          sm={12}
          md={7}
          lg={7}
          // elevation={6}
          // style={{ height: "100%" }}
        >
          {children}
        </Grid>
      </Grid>
    </>
  );
}

export default AuthLayout;
